import { InjectionToken } from '@angular/core';
export const projektApiUrl = new InjectionToken<string>('Projekt API URL');
export const projektEnvProduction = new InjectionToken<boolean>(
  'Projekt Environment Production',
);
